import { IonAlert } from "@ionic/react";
import { t } from "i18next";
import React, { useState } from "react";

export const SupportRequestSent = (props: any) => {
  const [isOpen, setIsOpen] = useState(true);
  const header = t("supportRequest") || "";
  const message = t("supportRequestDescription") || "";

  return (
    <IonAlert
      isOpen={isOpen}
      header={header}
      message={message}
      buttons={[
        {
          text: "OK",
          handler: () => {
            setIsOpen(false);
          },
        },
      ]}
    />
  );
};
